module.exports = __webpack_public_path__ + "front/img/edm-btn.7ad41662.png";